// extracted by mini-css-extract-plugin
export default {"container":"heroBanner_container__cVHHA","imgSingle":"heroBanner_imgSingle__QvHSQ"};